<div class="w-full flex justify-center px-2 sm:px-0 mt-[80px]">
    <div
        class="relative w-full backdrop-blur-[81.54845428466797px] bg-white/10 rounded-[36px] z-10 max-w-[350px] h-[340px] py-6 sm:py-[114px]">
        <div class="absolute top-[-60px] flex flex-col items-center justify-center w-full">
            <img class="h-[130px]" [src]="info.icon" alt="">
            <div class="font-outfit text-2xl font-semibold w-full text-center mt-[50px]">{{info.title}}</div>
            <div class="font-inter text-base w-full text-center px-[25px] mt-[15px]">{{info.text}}</div>
        </div>
    </div>
</div>